import React from 'react';
import { Container } from 'react-bootstrap';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <Container>
        <div className="footer-content">
          <p className="copyright-text">
            © {currentYear} <strong>2K Designs LLC</strong>. All rights reserved.
          </p>
          <p className="powered-by">
            Powered by <span className="brand-accent">RecurOrder</span>
          </p>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
